import { ISelectOption } from '../../../ui-toolkit';
import { getLanguageName } from '../../../utilities/getListOfLanguages';
import { SelectOption } from '../../../tailwindComponents/selectTW/interfaces';
import { getSimpleOffsetName, getSimpleTimeZoneList } from '../../../utilities/order/getListOfValidTimeZone';

const americanSignLangOption: ISelectOption<string> = {
  label: 'American Sign Language',
  value: 'American Sign Language',
};

export const sigSyncCompatibleLanguages: string[] = ['en', 'es', 'fr', 'de'];

export const languageOptions: ISelectOption<string>[] = sigSyncCompatibleLanguages
  .map((value) => ({
    label: getLanguageName(value),
    value: getLanguageName(value),
  }))
  .concat(americanSignLangOption);

export const witnessOptions: SelectOption[] = [
  {
    label: '0',
    value: 0,
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: 'N/A',
    value: null,
  },
];

export const timeZoneOptions: ISelectOption<string>[] = getSimpleTimeZoneList.map((zone: string) => ({
  label: getSimpleOffsetName(zone),
  value: zone,
}));
